import React, { useState, useEffect, useContext } from "react";
import QueueManager from "../QueueManager";
import { Grid } from "@material-ui/core";
import AppContent from "./AppContent";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import SearchAppContext from "../../common/lib/ApplicationQueue/searchedAppContext";
import { ApplicationDataAPI } from "../../common/lib/API/ApplicationDataAPI";

const AssetReview = (props) => {
	const [selectedApp, setSelectedApp] = useState({});
	// const [actionType, setActionType] = useState({});
	const [queueManagerOpen, setQueueManagerOpen] = useState(true);
	const [queueDrawerOpen, setQueueDrawerOpen] = useState(true);
	const toggleQueueDrawer = (val) => {
		setQueueDrawerOpen(val);
	};
	const useStyles = makeStyles((theme) => ({
		drawer: {
			flexShrink: 1,
			position: queueManagerOpen ? "relative" : "absolute",
		},
		drawerPaper: {
			position: "relative",
			zIndex: 999,
		},
	}));

	const { searchedApp, setSearchedApp } = useContext(SearchAppContext);

    useEffect(() => {
      if (searchedApp !== "" && searchedApp !== undefined) {
        onAppSelected(
          {
            action: "View",
          },
          searchedApp
        );
        setQueueDrawerOpen(false);
        setSearchedApp("");
      }
    }, [searchedApp]);

	const onAppSelected = async (actionType, selectedApp) => {
		if (window.handleContainerAppSelection) {
			window.handleContainerAppSelection(selectedApp);
		}
		if (actionType.action === "Unlock" || actionType.action === "Done")
			setSelectedApp({});
		else {
			setSelectedApp(
				await ApplicationDataAPI.fetchApplicationById(selectedApp.id, selectedApp.broker_id)
			);
		}
		props.setActionType(actionType);
	};

	window.toggleQueueDrawer = () => {
		if (queueManagerOpen) {
			let container = document.getElementById("drawer-container");
			let drawer = document.getElementById("qmanager-drawer");
			drawer.style.width = container.offsetWidth + "px";
		}
		setQueueManagerOpen(!queueManagerOpen);
	};

	useEffect(() => {
		window.addEventListener("resize", setContentHeight);
		setContentHeight();
		props.setStageName("ASSET REVIEW");
	}, []);

	const setContentHeight = () => {
		let height = 0;
		let body = window.document.body;
		let element = document.getElementById("asset-content");
		if (window.innerHeight) {
			height = window.innerHeight;
		} else if (body.parentElement.clientHeight) {
			height = body.parentElement.clientHeight;
		} else if (body && body.clientHeight) {
			height = body.clientHeight;
		}

		element.style.height = height - element.offsetTop + "px";
	};

	const classes = useStyles();

	return (
		<div>
			<Grid container>
			<Grid id="drawer-container" item xs={queueDrawerOpen ? 6 : 2} md={queueDrawerOpen ? 6 : 0}>
					<Drawer
						id="qmanager-drawer"
						className={classes.drawer}
						variant="persistent"
						anchor="left"
						open={queueManagerOpen}
						classes={{
							paper: classes.drawerPaper,
						}}>
						<QueueManager status="Asset Review" onAppSelected={onAppSelected} queueDrawerOpen={queueDrawerOpen} toggleQueueDrawer={toggleQueueDrawer} isQueueVisible={queueManagerOpen} />
					</Drawer>
				</Grid>
				<Grid
					Id="asset-content"
					align="center"
					item
					xs={queueDrawerOpen ? 6 : 10}
					className={classes.main_grid}
					style={{ overflowY: "auto", overflowX: "hidden" }}>
					<AppContent app={selectedApp} isReadOnly={props.actionType.action === "View"} />
				</Grid>
			</Grid>
		</div>
	);
};
export default AssetReview;
